import { useInfiniteQuery, useQuery } from "@tanstack/react-query";

import type { components } from "@/api/types";
import { PAGE_LIMIT, apiGet, apiGetPage, nextCursor, qk } from "@/shared/api";

type ChartPeriod = components["schemas"]["ChartPeriod"];

/**
 * Демо-счёт целиком: баланс, позиции, график, лимиты (доработки §3).
 *
 * Одна ручка вместо пары «главная + мои роботы» реального контура. Так устроен
 * и бэкенд: позиций не больше `demo_max_positions`, и второй запрос за тем же
 * списком был бы вторым источником одной правды.
 *
 * Счёт заводится этим же запросом — отдельного «открыть демо» не существует.
 */
export function useDemo(period: ChartPeriod) {
  return useQuery({
    queryKey: qk.demo(period),
    queryFn: ({ signal }) => apiGet("/api/v1/demo", { query: { period }, signal }),
  });
}

export function useDemoPosition(id: number, period: ChartPeriod) {
  return useQuery({
    queryKey: qk.demoPosition(id, period),
    queryFn: ({ signal }) =>
      apiGet("/api/v1/demo/positions/{position_id}", {
        params: { position_id: id },
        query: { period },
        signal,
      }),
  });
}

/** Лог демо-операций. Курсорная ручка — как и реальный лог кошелька. */
export function useDemoTransactions() {
  return useInfiniteQuery({
    queryKey: qk.demoTransactions(),
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam, signal }) =>
      apiGetPage("/api/v1/demo/transactions", {
        query: {
          limit: PAGE_LIMIT,
          ...(pageParam ? { cursor: pageParam } : {}),
        },
        signal,
      }),
    getNextPageParam: (last) => nextCursor(last.meta),
  });
}
